<template>
   <a-card :bordered="false">
     <!-- 查询区域 -->
     <div class="table-page-search-wrapper">
       <a-form layout="inline" @keyup.enter.native="searchQuery">
         <a-row :gutter="24">
           <a-col :xl="4" :lg="5" :md="7" :sm="24">
             <a-form-item label="账号">
               <a-input placeholder="请输入账号" v-model="queryParam['sys_user.username']"></a-input>
             </a-form-item>
           </a-col>
           <a-col :xl="4" :lg="5" :md="7" :sm="24">
             <a-form-item label="学生名">
               <a-input placeholder="请输入学生名" v-model="queryParam['sys_user.realname']"></a-input>
             </a-form-item>
           </a-col>
           <a-col :xl="4" :lg="5" :md="7" :sm="24">
             <a-form-item label="作品名">
               <a-input placeholder="作品名" v-model="queryParam.workNameLike"></a-input>
             </a-form-item>
           </a-col>
           <a-col :xl="4" :lg="5" :md="7" :sm="24">
             <a-form-item label="代码类型">
               <j-dict-select-tag placeholder="代码类型" v-model="queryParam.codeType" dictCode="code_type"/>
             </a-form-item>
           </a-col>
           <a-col :xl="4" :lg="5" :md="7" :sm="24">
             <a-form-item label="创作来源">
               <a-select v-model="queryParam.workScene" @change="workSceneChange">
                 <a-select-option value="">全部</a-select-option>
                 <a-select-option value="create">创作</a-select-option>
                 <a-select-option value="course">课程作业</a-select-option>
                 <!-- <a-select-option value="exam">考试</a-select-option> -->
                 <a-select-option value="additional">自定义作业</a-select-option>
               </a-select>
             </a-form-item>
           </a-col>
             <a-col :xl="4" :lg="5" :md="7" :sm="24">
               <a-form-item label="课程单元">
                 <j-search-select-tag placeholder="课程单元" v-model="queryParam.unitId" dict="teaching_course_unit,unit_name,id"/>
               </a-form-item>
             </a-col>
             <!-- <a-col :xl="4" :lg="5" :md="7" :sm="24">
               <a-form-item label="赛事">
                 <j-search-select-tag placeholder="请选择赛事" v-model="queryParam.contestId" dict="teaching_contest,contest_name,id"/>
               </a-form-item>
             </a-col> -->
           <a-col :xl="6" :lg="7" :md="8" :sm="24">
             <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
               <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
               <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
             </span>
           </a-col>
         </a-row>
       </a-form>
     </div>
     <!-- 查询区域-END -->
     <!-- table区域-begin -->
     <div>
       <a-table
         class="j-table-force-nowrap"
         :scroll="{x:true}"
         ref="table"
         size="middle"
         bordered
         rowKey="id"
         :columns="columns"
         :dataSource="dataSource"
         :pagination="ipagination"
         :loading="loading"
         @change="handleTableChange"
       >
         <span slot="rate" slot-scope="t">
           <a-rate :disabled="true" :value="t" />
         </span>
         <template slot="htmlSlot" slot-scope="text">
           <div v-html="text"></div>
         </template>
         <template slot="imgSlot" slot-scope="text">
           <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
           <img
             v-else
             :src="getImgView(text)" :preview="text"
             height="25px"
             alt="图片不存在"
             style="max-width: 80px; font-size: 12px; font-style: italic"
           />
         </template>
         <template slot="fileSlot" slot-scope="text">
           <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
           <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
             下载
           </a-button>
         </template>
 
         <span slot="action" slot-scope="text, record">
           <a @click="handleReview(record)">批改</a>
           <a-divider type="vertical" />
           <a @click="handlePreview(record)">预览</a>
           <a-divider type="vertical" />
           <a-dropdown>
             <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
             <a-menu slot="overlay">
               <a-menu-item v-if="record.codeType == 1 || record.codeType == 2">
                 <a-popover trigger="click">
                   <template slot="content">
                     <QrCode :value="url.shareUrl + record.id" :size="250"/>
                   </template>
                   <a>二维码</a>
                 </a-popover>
               </a-menu-item>
               <a-menu-item>
                 <a @click="handleSend(record.id)">克隆至其他账号</a>
               </a-menu-item>
               <!-- <a-menu-item>
                 <a @click="download(record.workFile_url)">下载作业文件</a>
               </a-menu-item> -->
               <a-menu-item>
                 <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                   <a>删除</a>
                 </a-popconfirm>
               </a-menu-item>
             </a-menu>
           </a-dropdown>
         </span>
       </a-table>
     </div>
 
     <teachingWork-modal ref="modalForm" @ok="modalFormOk"></teachingWork-modal>
     <TeachingWorkPreviewModal ref="previewModal"/>
     <TeachingWorkReviewModal ref="reviewModal" @finished="searchQuery" />
     <Select-User-Modal ref="selectUserModal" @selectFinished="selectStudentOK"></Select-User-Modal>
   </a-card>
 </template>
 
 <script>
 import QrCode from '@/components/tools/QrCode'
 import { postAction, getAction } from '@/api/manage'
 import { JeecgListMixin } from '@/mixins/JeecgListMixin'
 import TeachingWorkModal from './components/myClass/TeachingWorkModal'
 import TeachingWorkPreviewModal from './components/myClass/TeachingWorkPreviewModal'
 import TeachingWorkReviewModal from './components/myClass/TeachingWorkReviewModal'
 import SelectUserModal from './components/myClass/selector/SelectUserModal'
 import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
 import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
 import {
   getEditorUrl,
   getPlayerUrl,
   getCodeIcon,
 } from "@/utils/codeTypeUtil.js";
 
 export default {
   name: 'TeachingWorkList',
   mixins: [JeecgListMixin],
   components: {
     JDictSelectTag,
     TeachingWorkModal,
     TeachingWorkPreviewModal,
     TeachingWorkReviewModal,
     SelectUserModal,
     QrCode,
     JSearchSelectTag
   },
   data() {
     return {
       description: '作业列表管理页面',
       // 表头
       columns: [
         {
           title: '#',
           dataIndex: '',
           key: 'rowIndex',
           width: 60,
           align: 'center',
           customRender: function (t, r, index) {
             return parseInt(index) + 1
           },
         },
         {
           title: '作品名',
           align: 'center',
           width: 100,
           sorter: true,
           dataIndex: 'workName',
         },
         {
           title:'封面',
           align:"center",
           dataIndex: 'workCover_url',
           scopedSlots: {customRender: 'imgSlot'}
         },
         {
           title: '创作来源',
           align: 'center',
           width: 100,
           dataIndex: 'workScene',
           sorter: true,
           customRender(v){
             switch(v){
               case "create": return "自由创作"
               case "additional": return "班级作业"
               case "course": return "课程作业"
               case "exam": return "考试作品"
               default: return v
             }
           }
         },
           {
           title: '代码类型',
           align: 'center',
           width: 100,
           sorter: true,
           dataIndex: 'codeType_dictText',
         },
         {
           title: '状态',
           align: 'center',
           width: 100,
           sorter: true,
           dataIndex: 'workStatus_dictText',
         },     
         {
           title: '学生',
           align: 'center',
           dataIndex: 'realname',
           width: 120,
         },
         {
           title: '提交班级',
           align: 'center',
           width: 100,
           dataIndex: 'departId_dictText',
         },
         {
           title: '课程单元',
           align: 'center',
           width: 150,
           dataIndex: 'courseUnitId_dictText',
         },
         {
           title: '赛事',
           align: 'center',
           width: 150,
           dataIndex: 'contestId_dictText',
         },
         // {
         //   title: '评分',
         //   align: 'center',
         //   width: 180,
         //   dataIndex: 'score',
         //   sorter: true,
         //   scopedSlots: { customRender: 'rate' },
         // },
         {
           title: '首次提交时间',
           align: 'center',
           width: 140,
           sorter: true,
           dataIndex: 'createTime',
         },
         {
           title: "最新提交时间",
           align: "center",
           width: 150,
           dataIndex: "updateTime",
           sorter: true,
           customRender(v, r) {
             return r.updateTime || r.createTime;
           },
         },
         {
           title: '操作',
           dataIndex: 'action',
           align: 'center',
           fixed:"right",
           width: 160,
           scopedSlots: { customRender: 'action' },
         },
       ],
       url: {
         list: "/teaching/teachingWork/list",
         // list: '/teaching/teachingWork/teacherCourseWork',
         delete: '/teaching/teachingWork/delete',
         deleteBatch: '/teaching/teachingWork/deleteBatch',
         exportXlsUrl: '/teaching/teachingWork/exportXls',
         importExcelUrl: 'teaching/teachingWork/importExcel',
         sendWorkUrl: '/teaching/teachingWork/sendWork',
         shareUrl: window._CONFIG['webURL'] + '/scratch3/scratch-mobile.html?workId=',
       },
       dictOptions: {},
     }
   },
   computed: {
     importExcelUrl: function () {
       return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
     },
   },
   watch: {
     $route(to, from) {
       console.log(to)
       this.queryParam.workScene = to.path.split('workScene=')[1]
       this.searchQuery()
     },
   },
   created() {
     this.queryParam.workScene = this.$route.query.workScene || ''
     if (this.queryParam.workScene) {
       this.searchQuery()
     }
   },
   methods: {
     getEditorUrl,
     getPlayerUrl,
     getCodeIcon,
     initDictConfig() {},
     handlePreview(record) {
       this.$refs.previewModal.view(record)
     },
     handleReview(record){
       this.$refs.reviewModal.edit(record)
     },
     workSceneChange(v) {
       this.queryParam.workScene = v
       // this.$router.push({ path: this.$route.path, query: { workScene: v.target.value } })
       this.searchQuery()
     },
     handleSend(id) {
       this.sendWorkId = id
       this.$refs.selectUserModal.visible = true
     },
     selectStudentOK(data) {
       let params = {}
       params.sendWorkId = this.sendWorkId
       params.userIdList = []
       for (var a = 0; a < data.length; a++) {
         params.userIdList.push(data[a])
       }
       console.log(params)
       postAction(this.url.sendWorkUrl, params).then((res) => {
         if (res.success) {
           this.$message.success(res.message)
         } else {
           this.$message.warning(res.message)
         }
       })
     },
     download(url) {
       window.open(url)
     },
   },
 }
 </script>
 <style scoped>
 @import '~@assets/less/common.less';
 </style>